import React from 'react'
import Ratings from 'src/elements/rating/rating';
import ButtonTertiary from '../../elements/buttons/Button.tertiary';
import LinkBranded from '../../elements/links/Link.branded';
import Heading from '../../elements/typography/heading';
import Paragraph from '../../elements/typography/paragraph';
import { TextBlockContainer, TextBlockLinkContainer } from './text.block.courses.styles';

interface TextBlockProps {
  title: string;
  description: string;
  removeRating?: boolean;
  actionLink: {
    url: string;
    text: string;
    caption?: string;
  }
  actionButton: {
    text: string;
    onClick: () => void;
  }
}

const BannerCoursesTextBlock = ({ title, description, removeRating, actionLink, actionButton }: TextBlockProps): JSX.Element => {
  return (
    <TextBlockContainer>
      <Heading
        text={title}
        size="3.375em"
        sizeLg="2.5em"
        sizeSubLg="2em"
        sizeSubMd="1.5em"
        weight="normal"
      />
      <Paragraph
        text={description}
        size="1.5em"
        sizeLg="1.375em"
        sizeSubLg="1em"
        sizeSubMd="1.1875em"
        weight="light"
      />
      <TextBlockLinkContainer>
        <LinkBranded
          text={actionLink.text}
          caption={actionLink.caption}
          url={actionLink.url}
          justify="stretch"
          size="16px"
        />
        {
          actionButton?.text ?
            <ButtonTertiary
              text={actionButton.text}
              color="main"
              justify="left"
              cursor="pointer"
              onClick={actionButton.onClick}
              iconPosition={'left'}
              icon={<svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" ><g><rect fill="none" height="24" width="24" /></g><g><path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M9.5,16.5v-9l7,4.5L9.5,16.5z" /></g></svg>}
            />
            : null
        }
      </TextBlockLinkContainer>
      {
        removeRating ?
          null :
          <Ratings />
      }
    </TextBlockContainer>
  )
}

export default BannerCoursesTextBlock;
